import { render, staticRenderFns } from "./ClauseAdd.vue?vue&type=template&id=16edded6"
import script from "./ClauseAdd.vue?vue&type=script&lang=js"
export * from "./ClauseAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports